import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { transition } from '../../../shared/style-settings'

export const useDonatePublishedSummaryStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      width: '100%',
    },
    thanksImage: {
      display: 'block',
      width: '100%',
      maxWidth: 240,
      height: 'auto',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        maxWidth: 200,
      },
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1.5),
      width: '100%',
      textAlign: 'left',
      '& .MuiTypography-root': {
        width: '100%',
        textAlign: 'left',
        margin: 0,
        padding: 0,
      },
    },
    statusBadge: {
      padding: theme.spacing(0.5, 1.5),
      borderRadius: theme.shape.borderRadius * 2,
      fontSize: '0.75rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      backgroundColor: `${theme.palette.success.main}15`,
      color: theme.palette.success.dark,
    },
    statusBadgeDraft: {
      backgroundColor: `${theme.palette.warning.main}15`,
      color: theme.palette.warning.dark,
    },
    title: {
      fontSize: '1.125rem',
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.35,
    },
    price: {
      fontSize: '1.25rem',
      fontWeight: 700,
      color: theme.palette.primary.main,
    },
    metaRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      width: '100%',
    },
    metaChip: {
      padding: theme.spacing(0.5, 1.25),
      borderRadius: theme.shape.borderRadius * 2,
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.text.secondary,
      fontSize: '0.8125rem',
      fontWeight: 600,
    },
    description: {
      color: theme.palette.text.secondary,
      lineHeight: 1.6,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      marginTop: theme.spacing(0.5),
    },
    nonprofitLinkRow: {
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
      width: '100%',
    },
    nonprofitLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(1),
      width: '100%',
      boxSizing: 'border-box',
      padding: theme.spacing(1.5, 2.5),
      backgroundColor: `${theme.palette.primary.main}08`,
      border: `1px solid ${theme.palette.primary.main}30`,
      borderRadius: theme.shape.borderRadius * 2,
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 600,
      fontSize: '0.9375rem',
      transition: transition,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main}15`,
        borderColor: theme.palette.primary.main,
      },
      '& .MuiSvgIcon-root': {
        fontSize: '1.25rem',
      },
    },
  })
)
